
const digest = '5c555eeaa3d814e6deb6fb451dc5849e1a18101836f23752c9c073ac64757eb4';
const classes = {"warning":"_warning_1tn3o_1","warningBold":"_warningBold_1tn3o_10"};
const css = `._warning_1tn3o_1 {
  font-family: "Rubik", sans-serif;
  font-size: 14px;
  font-weight: 500;
  margin: 20px 0;
  color: #d81616;
  border-radius: 15px;
}

._warningBold_1tn3o_10 {
  font-weight: 600;
}`;

(function() {
  if (typeof document !== "undefined" && !document.getElementById(digest)) {
    var ele = document.createElement('style');
    ele.id = digest;
    ele.textContent = css;
    document.head.appendChild(ele);
  }
})();

export default classes;
export { css, digest, classes };
  